<template>
  <main-layout class="damage-detail" page-title="受灾详情">
    <div slot="main-content" class="main-content">
      <div class="first-el">
        <h3>灾害基础信息</h3>
        <div>
          <el-row>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">灾害名称：</div>
                <div class="field-item-content">
                  {{ detailInfo.disasterName }}
                </div>
              </div>
            </el-col>
            <el-col :span="16">
              <div class="field-item">
                <div class="field-item-title">可申报状态：</div>
                <div
                  class="field-item-content"
                  :class="`status${detailInfo.reportStatus}`"
                >
                  {{ damage_report_status[detailInfo.reportStatus] }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">发布单位：</div>
                <div class="field-item-content">
                  {{ detailInfo.publishSubjectName }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">发布人：</div>
                <div class="field-item-content">{{ detailInfo.publisher }}</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">发布时间：</div>
                <div class="field-item-content">
                  {{ detailInfo.publishTime || "--" }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-divider />
      <div>
        <h3>
          已申报地块列表
          <el-button
            v-if="detailInfo.reportStatus === 1"
            type="primary"
            size="small"
            class="add-btn"
            @click="addLand"
          >
            添加受灾地块
          </el-button>
        </h3>
        <div>
          <el-row>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">申报地块数：</div>
                <div class="field-item-content">
                  {{ detailInfo.landNumSum || "--" }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">申报地块面积：</div>
                <div class="field-item-content">
                  {{ detailInfo.landAcreSum || "--" }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">申报经济损失：</div>
                <div class="field-item-content">
                  {{ detailInfo.damageSum || "--" }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">受灾设施：</div>
                <div class="field-item-content">
                  {{ detailInfo.smallFacilities || "--" }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">成灾设施：</div>
                <div class="field-item-content">
                  {{ detailInfo.mediumFacilities || "--" }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">绝收设施：</div>
                <div class="field-item-content">
                  {{ detailInfo.largeFacilities || "--" }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">受灾露地：</div>
                <div class="field-item-content">
                  {{ detailInfo.smallOpen || "--" }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">成灾露地：</div>
                <div class="field-item-content">
                  {{ detailInfo.mediumOpen || "--" }}
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="field-item">
                <div class="field-item-title">绝收露地：</div>
                <div class="field-item-content">
                  {{ detailInfo.largeOpen || "--" }}
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div>
        <div class="select-box">
          <!--          <el-select v-model="selectType" @change="currentChange(1)">-->
          <!--            <el-option value="" label="全部申报地块" />-->
          <!--            <el-option :value="1" label="审核拒绝地块" />-->
          <!--            <el-option :value="0" label="非审核拒绝地块" />-->
          <!--          </el-select>-->
          <el-tabs v-model="selectType" @tab-click="currentChange(1)">
            <el-tab-pane label="全部申报地块" name="null" />
            <el-tab-pane label="非审核拒绝地块" name="0" />
            <el-tab-pane label="审核拒绝地块" name="1" />
            <el-tab-pane label="审核通过地块" name="2" />
          </el-tabs>
          <div>
            <el-button
              v-if="selectType === '1'"
              :disabled="!dataList.length"
              type="primary"
              size="small"
              class="add-btn"
              @click="batchCheck"
            >
              批量重新申报
            </el-button>
          </div>
        </div>
        <table-list
          ref="tabList"
          v-if="detailInfo.reportStatus != undefined"
          class="tablelist"
          :list="dataList"
          :isShow="apiData"
          :loading="tableLoading"
          :reportStatus="detailInfo.reportStatus"
          @getList="getInfo"
        />
        <pagiation
          :total="total"
          :pageSize="queryParams.pageSize"
          :pageNo="queryParams.pageNo"
          @currentChange="currentChange"
          :pagisShow="apiData"
          v-if="apiData"
        />
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import TableList from "./DetailTableList/index";
import Pagiation from "@/components/Pagiation.vue";
import { getDamageDetail, getDamagelabdList } from "@/api/request/snkd.produce";
import sameIn from "@/mixins/listsdetails";
import { damage_report_status } from "@/confing/map_tab";
import { mapActions } from "vuex";

export default {
  name: "detailInfo",
  mixins: [sameIn],
  components: {
    MainLayout,
    TableList,
    Pagiation,
  },
  data() {
    return {
      damage_report_status,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      detailInfo: {},
      dataList: [],
      total: 0,
      tableLoading: false,
      apiData: true,
      selectType: "null",
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    getInfo() {
      const params = {
        disasterId: this.$route.query.id,
        farmId: this.farmId,
      };
      getDamageDetail(params).then((res) => {
        this.detailInfo = res.obj;
      });
      params["report"] = this.selectType;
      this.tableLoading = true;
      getDamagelabdList({
        ...params,
        ...this.queryParams,
      }).then((res) => {
        this.dataList = res.obj.list;
        this.apiData = !!res.obj.list.length;
        this.total = res.obj.totalCount;
        this.tableLoading = false;
      });
    },
    currentChange(pageNo) {
      this.queryParams.pageNo = pageNo;
      this.getInfo();
    },
    async addLand() {
      if (await this.hasPermission("produce:disaster:add")) {
        this.$router.push({
          path: "/damage-increase-land",
          query: {
            id: this.$route.query.id,
            name: this.detailInfo.disasterName,
          },
        });
      } else {
        this.$message({
          message: "您的权限无法使用该功能，可联系超级管理员修改权限",
          type: "warning",
        });
      }
    },
    async batchCheck() {
      if (await this.hasPermission("produce:disaster:batchRepeat")) {
        this.$router.push({
          path: "/damage-increase-land",
          query: {
            id: this.$route.query.id,
            name: this.detailInfo.disasterName,
            landIds: this.dataList.map((i) => i.landId),
          },
        });
      } else {
        this.$message({
          message: "您的权限无法使用该功能，可联系超级管理员修改权限",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.damage-detail {
  .main-content {
    width: 1200px;
    min-height: calc(100vh - 80px);
    background: #fff;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box;
    .first-el {
      padding-top: 30px;
    }
    h3 {
      font-size: 20px;
      color: $--color-primary;
      padding-bottom: 20px;
      .add-btn {
        float: right;
        margin-top: -8px;
      }
    }
    .field-item {
      display: flex;
      padding: 10px 0;
      font-size: 16px;
      color: #303133;
      font-family: Microsoft YaHei;
      &-title {
        margin-right: 12px;
      }
      .status0 {
        color: #dc9b04;
      }
      .status1 {
        color: $--color-primary;
      }
      .status2 {
        color: #d83931;
      }
    }
    .select-box {
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  ::v-deep.el-table {
    border: 0;
    th,
    tr,
    td {
      border: 0;
    }
    &::before {
      height: 0;
    }
  }
  ::v-deep .el-table {
    height: 100%;
    .el-table__body-wrapper {
      table {
        padding-bottom: 0 !important;
      }
    }
  }
  ::v-deep .el-table th,
  .el-table tr {
    background-color: #eefff9;
  }
}
</style>
